import React, { useEffect, useState } from "react";
import PaymentSuccessLogo from "../../assets/svg/success.svg";
import PrimaryButton from "../../components/Button/PrimaryButton";
import SendLogo from "../../assets/svg/send.svg";
import SendWhiteLogo from "../../assets/svg/send-white.svg";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import ROUTE_PATH from "../../constant/route";
import { fetchPaymentStatus } from "../../store/reducers/prosure/apiThunk";
import { AppDispatch } from "../../store/store";
import { showToast } from "../../components/Toast";
import {
  resetDetail,
  updateFailed,
  updateSuccess,
  updateTransactionTimer,
} from "../../store/reducers/prosure";
import CircularProgress from "@mui/material/CircularProgress";
import { resetPrice } from "../../store/reducers/home";
import { updateLoading } from "../../store/reducers/loader";
const PaymentSuccess = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<AppDispatch>();
  const userData = useSelector((state: any) => state);
  const {
    prosure: {
      formDetail,
      otpVerified,
      paymentData,
      successUpdate,
      transactionTimer,
    },
    home: { totalPrice },
  } = userData;
  const [flag, setFlag] = useState(true);
  useEffect(() => {
    if (Number(totalPrice) === 0) {
      navigate(ROUTE_PATH.HOME);
    } else if (Object.keys(formDetail)?.length === 0) {
      navigate(ROUTE_PATH.CUSTOMER_DETAILS);
    } else if (otpVerified === false) {
      navigate(ROUTE_PATH.CUSTOMER_DETAILS);
    }
  }, []);

  useEffect(() => {
    statusAPI(transactionTimer);
  }, []);

  const recApi = (item: any) => {
    dispatch(updateTransactionTimer(item));
    if (item === 100000) {
      dispatch(updateSuccess(false));
      setFlag(false);
      dispatch(updateFailed(true));
      navigate(ROUTE_PATH.FAILURE_PAYMENT);
      return;
    } else {
      statusAPI(item);
    }
  };

  const statusAPI = async (item: any) => {
    if (!successUpdate) {
      try {
        const res = await dispatch(
          fetchPaymentStatus(paymentData?.transactionId)
        ).unwrap(); // Unwraps to return raw result or throw error
        if (res?.status === 1) {
          if (res?.data?.status === "SUCCESS") {
            dispatch(updateSuccess(true));
            setFlag(false);
            return;
          } else {
            setFlag(true);
            dispatch(updateSuccess(false));
            setTimeout(() => {
              recApi(item + 20000);
            }, 5000);
          }
        }
      } catch (error) {
        dispatch(updateSuccess(false));
        setFlag(false);
        showToast("Something went wrong", "error");
        console.error("Error saving user data:", error);
      }
    }
  };

  return (
    <div className="sm:flex items-center justify-center w-[100%] h-[100vh] bg-bg-color-3 sm:bg-bg-color-5 relative">
      {flag ? (
        <div className="flex justify-center flex-col items-center pt-[20px] lg:p-[0]">
          <div className="font-bold text-[12px] flex items-center">
            <CircularProgress
              style={{
                marginRight: "5px",
              }}
              size="15px"
            />
            Please Wait...
          </div>
          <div className="font-bold text-[12px]">
            Your payment is currently being processed
          </div>
          <br />
          <div className="text-[12px]">
            Please do not refresh or close your browser.
          </div>
        </div>
      ) : (
        <>
          <div className="bg-bg-color-3 pt-[20px] pb-[14px] px-[16px] sm:py-[30px] sm:pb-0 sm:w-[70%] lg:w-[60%]  xl:w-[45%] sm:px-[88px] sm:rounded-[30px] bg-bg-color-3 sm:shadow-custom-light">
            <div className="flex flex-col items-center justify-center sm:mb-[36px] mb-[24px]">
              <img
                src={PaymentSuccessLogo}
                alt="FailureWebLogo"
                className="h-[110px] mb-[16px]"
              />
              <div className="sm:text-[16px] text-[16px] sm:leading-[20px] leading-[20px] font-bold text-text-color-6 text-center ">
                Thank you!
                <br />
                Payment Successful
              </div>
              <div className="bg-bg-color-4 p-[30px] hidden sm:block rounded-[25px] mt-[16px] w-[100%] text-center text-">
                <div className="text-[14px] leading-[18px] font-bold text-bg-color-5 pb-[14px] flex items-center justify-center">
                  <img
                    src={SendWhiteLogo}
                    alt="SendLogo"
                    className="mr-[5px]"
                  />
                  Confirmation sent to{" "}
                  {formDetail?.firstName + " " + formDetail?.lastName}
                </div>
                <div className="text-[12px] leading-[18px] text-bg-color-5 pb-[4px]">
                  Email address : {formDetail?.email}
                </div>
                <div className="text-[12px] leading-[18px] text-bg-color-5 pb-[14px]">
                  Mobile no. : {formDetail?.mobileNo}
                </div>
                {/* <div className="text-[12px] leading-[18px] text-bg-color-5">
              It includes details on how to access your services, including
              HospiCash Insurance and Wellness Benefits.
            </div> */}
                <div className="text-[12px] leading-[18px] text-bg-color-5">
                It includes details on how to access wellness benefits.
                  {/* and CoverSure Platform. */}
                </div>
              </div>
              <div className="text-[11px] leading-[18px] py-[16px] text-text-color-8 font-semibold hidden sm:block">
                For any queries reach out to{" "}
                <a href="mailto:support@coversure.in">support@coversure.in</a>
              </div>
              <div className="w-[100%] hidden sm:block">
                <PrimaryButton
                  label={
                    <div className="flex items-center justify-center w-[100%] font-black">
                      <div className="text-[14px] leading-[18px] lg:text-[18px] lg:leading-[18px] font-semibold">
                        Restart client journey
                      </div>
                    </div>
                  }
                  onClick={() => {
                    dispatch(resetDetail({}));
                    dispatch(resetPrice(0));
                    dispatch(updateLoading(false));
                    navigate(ROUTE_PATH.HOME);
                  }}
                  classname="w-[100%]"
                />
              </div>
            </div>
          </div>
          <div className="absolute bottom-0 w-[100%] block sm:hidden">
            <div className="bg-bg-color-7 p-[16px] w-[100%]">
              <div className="text-[14px] leading-[18px] font-bold text-text-color-1 pb-[14px] flex items-center">
                <img src={SendLogo} alt="SendLogo" className="mr-[5px]" />
                Confirmation sent to{" "}
                {formDetail?.firstName + " " + formDetail?.lastName}
              </div>
              <div className="text-[12px] leading-[18px] text-text-color-1 pb-[4px]">
                Email address : {formDetail?.email}
              </div>
              <div className="text-[12px] leading-[18px] text-text-color-1 pb-[14px]">
                Mobile no. : {formDetail?.mobileNo}
              </div>
              {/* <div className="text-[12px] leading-[18px] text-text-color-1">
            It includes details on how to access your services, including
            HospiCash Insurance and Wellness Benefits.
          </div> */}
              <div className="text-[12px] leading-[18px] text-text-color-1">
                It includes details on how to access including Wellness Benefits
                and CoverSure Platform.
              </div>
              <div className="text-[11px] leading-[18px] pt-[10px] text-text-color-8 font-semibold text-center">
                For any queries reach out to{" "}
                <a href="mailto:support@coversure.in">support@coversure.in</a>
              </div>
            </div>
            <div
              className="bg-text-color-6 text-bg-color-5 w-[100%] p-[10px] text-center text-[12px] leading-[18px] font-semibold cursor-pointer"
              onClick={() => {
                navigate(ROUTE_PATH.HOME);
                dispatch(resetDetail({}));
                dispatch(resetPrice(0));
                dispatch(updateLoading(false));
              }}
            >
              Restart client journey
            </div>
          </div>
        </>
      )}
    </div>
  );
};

export default PaymentSuccess;
